import React from "react";
import { Link } from "react-router-dom";
import { VerdictBadge } from "./VerdictBadge";

/**
 * What the Result column means, above the table that uses it.
 *
 * The badges grade a direction, not whether the close landed inside the range,
 * and the difference is not guessable from the words alone — "No call" in
 * particular reads as missing data rather than as the answer it is. Most rows
 * carry one, so leaving it to a link nobody follows means most of the column
 * is unexplained.
 *
 * The threshold is stated as a number rather than described, because it is a
 * number a reader can check against the range printed two columns to the left:
 * add its two ends and see which side of 0.2% the sum falls. An explanation
 * that cannot be checked against the row beside it is decoration.
 *
 * Kept to two sentences. The full reasoning — why the cost of trading is the
 * right threshold, what happens to a no-call's score — is a page away, and
 * repeating it here would put an essay above every table.
 */
const ResultLegend = () => (
  <div className="text-muted fs-12 mb-2">
    <VerdictBadge verdict="right" />
    <VerdictBadge verdict="wrong" />
    <VerdictBadge verdict="no-call" />
    <span className="ms-1">
      grade the direction, not whether the close landed inside the range. Add the
      two ends of a forecast range together: lean over +0.2% is a call up, under
      &minus;0.2% a call down, and anything between is no call — a range that
      sits on the price it started from.{" "}
      <Link to="/how-scoring-works">How scoring works</Link>.
    </span>
  </div>
);

export default ResultLegend;
